"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateContactStatus = exports.setSearchQuery = exports.setSearchContactResult = exports.setPendingContactsLoaded = exports.setPendingContacts = exports.setNbContacts = exports.setCurrentPage = exports.setAcceptedContactsLoaded = exports.searchRelation = exports.removePendingContact = exports.rejectContact = exports.getSingleContact = exports.getNewPageOfContacts = exports.deleteContact = exports.addPendingContact = exports.addNewContact = exports.addNbContacts = exports.acceptContact = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var acceptContact = _user => ({
  type: types.ACCEPT_CONTACT,
  _user
});
exports.acceptContact = acceptContact;
var addNbContacts = nbToAdd => ({
  type: types.ADD_NB_CONTACTS,
  nbToAdd
});
exports.addNbContacts = addNbContacts;
var addNewContact = user => ({
  type: types.ADD_NEW_CONTACT,
  user
});
exports.addNewContact = addNewContact;
var addPendingContact = _pendingContact => ({
  type: types.ADD_PENDING_CONTACT,
  _pendingContact
});
exports.addPendingContact = addPendingContact;
var deleteContact = _user => ({
  type: types.DELETE_CONTACT,
  _user
});
exports.deleteContact = deleteContact;
var getNewPageOfContacts = () => ({
  type: types.GET_NEW_PAGE_OF_CONTACTS
});
exports.getNewPageOfContacts = getNewPageOfContacts;
var getSingleContact = _user => ({
  type: types.GET_SINGLE_CONTACT,
  _user
});
exports.getSingleContact = getSingleContact;
var rejectContact = _user => ({
  type: types.REJECT_CONTACT,
  _user
});
exports.rejectContact = rejectContact;
var removePendingContact = _pendingContact => ({
  type: types.REMOVE_PENDING_CONTACT,
  _pendingContact
});
exports.removePendingContact = removePendingContact;
var searchRelation = (page, sip, limit) => ({
  type: types.REQUEST_GET_SEARCH_CONTACTS,
  page,
  sip,
  limit
});
exports.searchRelation = searchRelation;
var setAcceptedContactsLoaded = loaded => ({
  type: types.SET_ACCEPTED_CONTACTS_LOADED,
  loaded
});
exports.setAcceptedContactsLoaded = setAcceptedContactsLoaded;
var setCurrentPage = currentPage => ({
  type: types.SET_CURRENT_PAGE,
  currentPage
});
exports.setCurrentPage = setCurrentPage;
var setNbContacts = nbContacts => ({
  type: types.SET_NB_CONTACTS,
  nbContacts
});
exports.setNbContacts = setNbContacts;
var setPendingContacts = pendingContacts => ({
  type: types.SET_PENDING_CONTACTS,
  pendingContacts
});
exports.setPendingContacts = setPendingContacts;
var setPendingContactsLoaded = loaded => ({
  type: types.SET_PENDING_CONTACTS_LOADED,
  loaded
});
exports.setPendingContactsLoaded = setPendingContactsLoaded;
var setSearchContactResult = _searchResults => ({
  type: types.SET_SEARCH_CONTACT_RESULT,
  _searchResults
});
exports.setSearchContactResult = setSearchContactResult;
var setSearchQuery = query => ({
  type: types.SET_SEARCH_QUERY,
  query
});
exports.setSearchQuery = setSearchQuery;
var updateContactStatus = (_user, status) => ({
  type: types.UPDATE_CONTACT_STATUS,
  _user,
  status
});
exports.updateContactStatus = updateContactStatus;